import React from 'react'
import ProductionStageHeader from './ProductionStageTable/ProductionStageHeader'
import ProductionStageRow from './ProductionStageTable/ProductionStageRow'

function ProductionStageTable(props) {
    const { listData, loading, reload } = props

    return (
        <div className='ProductionStageTable mt-3'>
            <div className="wrapTable">
                <table className='table mb-4'>
                    <ProductionStageHeader />
                    <tbody className='ProductionStageRow'>
                        {
                            !!listData && listData.map((item, i) => {
                                return <ProductionStageRow
                                    key={item._id}
                                    index={i}
                                    item={item}
                                    reload={reload}
                                />
                            })
                        }
                        {
                            !loading && listData.length === 0 &&
                            <tr>
                                <td colSpan={5}>
                                    No result
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </div>
    )
}

export default ProductionStageTable